import { Star } from "lucide-react";
import { SITE } from "@/lib/content";

const GoogleG = () => (
  <svg viewBox="0 0 48 48" className="h-8 w-8" aria-hidden="true">
    <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z" />
    <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" />
    <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z" />
    <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z" />
  </svg>
);

export function ReviewStrip() {
  const href = SITE.googleReviewsUrl;
  return (
    <section data-testid="google-review-strip" className="border-y border-forest/10 bg-beige-soft">
      <div className="wrap flex flex-col items-start gap-5 py-8 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-4">
          <GoogleG />
          <div>
            <div className="flex gap-0.5 text-gold">{Array.from({ length: 5 }).map((_, i) => <Star key={i} className="h-4 w-4 fill-current" />)}</div>
            <p className="mt-1 text-sm font-semibold text-charcoal">Google reviews <span className="font-normal text-charcoal-soft">· [rating & review count to be added]</span></p>
          </div>
        </div>
        <p className="max-w-md font-display text-2xl italic text-forest">Read what clients say, in their own words.</p>
        {href ? (
          <a href={href} target="_blank" rel="noreferrer" className="btn-ghost !py-3" data-testid="google-reviews-link">Read reviews</a>
        ) : (
          <span className="rounded-full border border-dashed border-gold/60 px-5 py-3 text-xs font-semibold uppercase tracking-widest text-gold-ink" data-testid="google-reviews-link">[Google link pending]</span>
        )}
      </div>
    </section>
  );
}
